// ReduxContext.ts
import React from 'react';
import type { AppStore } from './redux-types';

export const ReduxContext = React.createContext<AppStore | null>(null);
